import * as Sentry from '@sentry/react';

export function assertNever(value: never): never {
  Sentry.captureException(`Unhandled discriminated union member: ${JSON.stringify(value)}`);
  throw new Error(`Unhandled discriminated union member: ${JSON.stringify(value)}`);
}
